import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { RadioElement, getDefaultCargoRequestValue, NOT_RESET_FIELDS, displayValue } from './common';
import { Checkbox, TextField } from 'material-ui';

import CollapseCustomizable from 'components/common/CollapseCustomizable';
import { updateCargoOrder as updateCargoOrderAction } from 'actions/cargoes/orders';
import helpers from 'helpers';

function Unpacked({
    updateCargoOrder,
    numberOrderTable,
    cargoPackingIndex,
    cargoOrder,
    cargoPacking,
    canCheck = false,
}) {
    const [disabledAll, setDisableAll] = useState(false);
    const [stackableDisabled, setStackableDisabled] = useState(false);

    /**
     * 
     * @param {string} fieldPath field path
     * @param {any} value 
     * @param {{ fieldPath: string, value: any }[]} multiple
     */
    const modifyField = (fieldPath, value, multiple = []) => {
        const newCargoOrder = _.cloneDeep(cargoOrder);

        if (multiple.length) {
            multiple.forEach((item) => {
                _.set(newCargoOrder.cargo[cargoPackingIndex].packing, item.fieldPath, item.value);
            });
        } else {
            _.set(newCargoOrder.cargo[cargoPackingIndex].packing, fieldPath, value);
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    useEffect(() => {
        if (cargoOrder.cargo[cargoPackingIndex].packing.category !== 'unpacked') {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');

            NOT_RESET_FIELDS.forEach((field) => {
                metaPack[field] = cargoPacking.pack[field];
            });

            setDisableAll(true);
            modifyField('pack', metaPack);
        } else {
            setDisableAll(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].packing.category]);

    useEffect(() => {
        const { details } = cargoOrder.cargo[cargoPackingIndex];
        const { pack: metaPack } = getDefaultCargoRequestValue('packing');

        if (details === 1) {
            setStackableDisabled(true);
            modifyField('pack.stackable', metaPack.stackable);
        } else {
            setStackableDisabled(false);
        }
    }, [cargoOrder.cargo[cargoPackingIndex].details]);

    const changeStackable = () => {
        const newStackableValue = !cargoPacking.pack.stackable.value;

        const newCargoOrder = _.cloneDeep(cargoOrder);

        newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable.value = newStackableValue;

        if (!newStackableValue) {
            const { pack: metaPack } = getDefaultCargoRequestValue('packing');

            newCargoOrder.cargo[cargoPackingIndex].packing.pack.stackable = metaPack.stackable;
        }

        updateCargoOrder(numberOrderTable, newCargoOrder);
    };

    return (<div><CollapseCustomizable
        _key='unpacked'
        head={
            <RadioElement
                checkedValue={cargoPacking.category}
                value='unpacked'
                disabled={!canCheck}
                onCheck={() => modifyField('category', 'unpacked')}
                label='unpacked'
                _key='unpacked'
            />}
        headStyle={{ borderBottom: '1px solid #E0E0E0' }}
        body={
            <React.Fragment>
                <div
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <TextField
                            value={displayValue(
                                cargoPacking,
                                'pack.unitsQuantity',
                                disabledAll,
                            )}
                            hintText='Number of units'
                            floatingLabelText='Number of units'
                            disabled={disabledAll}
                            style={{
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e =>
                                modifyField(
                                    undefined, undefined,
                                    [
                                        { fieldPath: 'pack.unitsQuantity', value: helpers.clearLetters(e.target.value).replace(/\./g, '') },
                                        { fieldPath: 'pack.bundlesQuantity', value: helpers.clearLetters(e.target.value).replace(/\./g, '') },
                                    ],
                                )
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField
                            value={displayValue(
                                cargoPacking,
                                'pack.unitLength.value',
                                disabledAll,
                            )}
                            hintText='Max Length, mm'
                            floatingLabelText='Max Length, mm'
                            disabled={disabledAll}
                            type='number'
                            style={{
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e =>
                                modifyField('pack.unitLength.value', helpers.clearLetters(e.target.value).replace(/\./g, ''))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField
                            value={displayValue(
                                cargoPacking,
                                'pack.unitBeam.value',
                                disabledAll,
                            )}
                            type='number'
                            hintText='Max Beam, mm'
                            floatingLabelText='Max Beam, mm'
                            disabled={disabledAll}
                            style={{
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e =>
                                modifyField('pack.unitBeam.value', helpers.clearLetters(e.target.value).replace(/\./g, ''))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField
                            value={displayValue(
                                cargoPacking,
                                'pack.unitHeight.value',
                                disabledAll,
                            )}
                            type='number'
                            hintText='Max Height, mm'
                            floatingLabelText='Max Height, mm'
                            disabled={disabledAll}
                            style={{
                                width: '100%',
                                fontSize: '13px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e =>
                                modifyField('pack.unitHeight.value', helpers.clearLetters(e.target.value).replace(/\./g, ''))
                            }
                        />
                    </div>
                </div>
                <div
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <TextField
                            value={displayValue(
                                cargoPacking,
                                'pack.unitWeight.value',
                                disabledAll,
                            )}
                            hintText='Unit Weight, mt'
                            floatingLabelText='Unit Weight, mt'
                            disabled={disabledAll}
                            style={{
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e =>
                                modifyField('pack.unitWeight.value', helpers.clearLetters(e.target.value))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <Checkbox
                            label='Stackable'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.value',
                                disabledAll,
                            )}
                            onCheck={changeStackable}
                            disabled={disabledAll || stackableDisabled}
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField
                            value={displayValue(
                                cargoPacking,
                                'pack.stackable.tiers',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            hintText='Tiers'
                            floatingLabelText='Tiers'
                            style={{
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onKeyDown={helpers.preventFloatKeyDown}
                            onChange={e =>
                                modifyField('pack.stackable.tiers', helpers.clearLetters(e.target.value).replace(/\./g, ''))
                            }
                        />
                    </div>
                    <div className='col-xs-3'>
                        <Checkbox
                            label='Inter-tier dunn...'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.dunnaging',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            onCheck={
                                () => modifyField('pack.stackable.dunnaging', !cargoPacking.pack.stackable.dunnaging)
                            }
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                </div>
                <div
                    className='row'
                    style={{ width: '100%' }}
                >
                    <div className='col-xs-3'>
                        <Checkbox
                            label='Nested'
                            checked={!!displayValue(
                                cargoPacking,
                                'pack.stackable.nested',
                                disabledAll,
                            )}
                            disabled={!cargoPacking.pack.stackable.value || disabledAll}
                            onCheck={
                                () => modifyField('pack.stackable.nested', !cargoPacking.pack.stackable.nested)
                            }
                            style={{
                                marginTop: '28px',
                            }}
                        />
                    </div>
                </div>
            </React.Fragment>
        }
    />
    </div>);
}

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        const cargoPacking = cargoOrder.cargo[ownProps.cargoPackingIndex].packing;
        return {
            cargoOrder,
            cargoPacking,
        };
    },
    dispatch => bindActionCreators({
        updateCargoOrder: updateCargoOrderAction,
    }, dispatch),
)(Unpacked));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Unpacked.jsx